import React from 'react'
import { styled } from '@mui/material/styles'
import { Container } from '@mui/material'
import Skeleton from '@mui/material/Skeleton'

const PREFIX = 'SkeltonListView'

const classes = {
  marginTopSpacing1: `${PREFIX}-marginTopSpacing1`,
}

const StyledContainer = styled(Container)(({ theme }) => ({
  [`&.${classes.marginTopSpacing1}`]: {
    marginTop: theme.spacing(1),
  },
}))

export const SkeltonListView = () => (
  <StyledContainer
    className={classes.marginTopSpacing1}
    data-testid="skeleton-list-view"
    maxWidth="md"
  >
    {[...new Array(10)].map((row) => (
      <Skeleton
        key={row}
        className={classes.marginTopSpacing1}
        variant="rectangular"
        height={83}
        width="100%"
      />
    ))}
  </StyledContainer>
)
